import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ContactCard from "../../component/ContactCard";
import { Timeline, TimelineBlock } from "../../component/Timeline";
import Image from "../../component/Image";
import Rules from "../../component/Rules";
import Pricing from "../../component/Pricing";
import Countdown from "../../component/Countdown";

const rules = [
  "Peserta merupakan Mahasiswa aktif program studi D3/D4/S1 sederajat dari seluruh perguruan tinggi di Indonesia yang dibuktikan dengan Kartu Tanda Mahasiswa (KTM).",
  "Perlombaan dapat diikuti oleh individu atau tim yang terdiri dari 2 orang dengan 1 peserta sebagai ketua.",
  "Peserta diperbolehkan berasal dari jurusan yang berbeda, namun tetap dari perguruan tinggi yang sama.",
  "Peserta yang sudah mendaftar tidak boleh digantikan oleh orang lain dengan alasan apapun.",
  "Peserta diperbolehkan mengikuti lebih dari 1 cabang lomba dengan ketentuan hanya bisa menjadi ketua di salah satu cabang lomba.",
  "Peserta tidak diperbolehkan mendaftar untuk dua atau lebih tim yang berbeda dalam satu cabang perlombaan yang sama.",
  "Peserta hanya diperbolehkan untuk memilih 1 cabang perlombaan ketika peserta tersebut dinyatakan menjadi finalis di lebih dari 1 cabang lomba.",
  "Peserta wajib mengunggah twibbon ARSEN 2026 di instagram pribadi dengan akun publik selama rangkaian kegiatan berlangsung dan tag @himasta_unair, @arsenunair, serta 3 akun teman lainnya menggunakan caption yang telah disediakan. twibbon dan caption dapat diunduh pada link berikut : https://bit.ly/TwibbonASECARSEN2026",
  "Peserta yang dianggap sah adalah peserta yang telah mendaftar secara sah oleh panitia dan mengikuti prosedur hingga selesai.",
  "Peserta wajib mematuhi segala peraturan yang telah ditetapkan oleh panitia dan jika peserta melanggar peraturan ASEC 2026 maka akan diberikan sanksi sesuai peraturan yang berlaku.",
];

function Asec() {
  const [isCountdownEnded, setIsCountdownEnded] = useState(false);

  useEffect(() => {


    const targetDate = new Date("2026-08-15T09:00:00+07:00");
    const now = new Date();
    setIsCountdownEnded(now >= targetDate);

    const interval = setInterval(() => {
      const currentTime = new Date();
      setIsCountdownEnded(currentTime >= targetDate);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col gap-3 text-center md:text-left max-w-6xl mx-auto w-full px-5 sm:px-8 my-16">
      <div className="flex items-center flex-col md:flex-row gap-3 py-8">
        <div className="flex flex-col gap-3">
          <div data-aos="fade-up">
            <div className="font-bold text-sm tracking-widest text-arsen-secondary-500 uppercase">
              CABANG KEGIATAN
            </div>
            <div className="text-5xl md:text-6xl font-bold">
              <span className="text-arsen-secondary">A</span>irlangga{" "}
              <span className="text-arsen-secondary">S</span>tatistics{" "}
              <span className="text-arsen-secondary">E</span>ssay{" "}
              <span className="text-arsen-secondary">C</span>ompetition
            </div>
          </div>
          <div
            data-aos="fade-up"
            data-aos-delay="100"
            className="bg-arsen-secondary-100 text-arsen-secondary rounded-full md:w-fit px-4 py-1 font-medium text-sm"
          >
            Tingkat Mahasiswa se-Indonesia
          </div>
          <div data-aos="fade-up" data-aos-delay="150">
            <div className="font-bold text-sm tracking-widest text-arsen-secondary-500 uppercase">
              TEMA KOMPETISI
            </div>
            <div className="text-sm md:text-lg leading-6 text-gray-700">
              Transforming Data from Fragmented Realities into Clarity through
              Statistical Method to Navigate Global Volatility
            </div>
          </div>
          {isCountdownEnded && (
            <div
              data-aos="fade-up"
              data-aos-delay="200"
              className="flex flex-col md:flex-row gap-2.5 text-md md:text-lg text-center md:text-left text-white mb-8"
            >
              <Link
                to="https://bit.ly/PendaftaranASEC2026"
                target="_blank"
                className="bg-arsen-secondary md:w-fit text-center px-8 py-3 rounded-lg transition duration-500 hover:bg-black hover:shadow-xl"
              >
                Daftar Sekarang
              </Link>
              <Link
                to="https://bit.ly/GuidebookASEC2026"
                target="_blank"
                className="text-center text-arsen-secondary border border-arsen-secondary md:w-fit px-8 py-3 rounded-lg transition duration-500 hover:bg-black hover:text-white hover:shadow-xl"
              >
                Panduan Kegiatan
              </Link>
              <a
                href="#timeline"
                className="text-center text-arsen-secondary border border-arsen-secondary md:w-fit px-8 py-3 rounded-lg transition duration-500 hover:bg-black hover:text-white hover:shadow-xl"
              >
                Timeline Kompetisi
              </a>
            </div>
          )}
          <div data-aos="fade-up" data-aos-delay="250" className="mt-4">
            <Countdown
              targetDate="2026-08-15T09:00:00+07:00"
              title="Countdown Pembukaan Lomba (15 Agustus 2026 09.00)"
            />
          </div>
        </div>
        <div
          data-aos="fade-up"
          className="relative md:ml-4 text-white text-center justify-center"
        >
          <img
            src="/assets/img/logo/asec2026.svg"
            alt="ASEC 2026 Logo"
            width="400"
            className="w-full max-w-[400px] h-auto"
          />
          <img
            src="/assets/img/mascot/mascot5.svg"
            alt=""
            className="absolute bottom-0 -right-2 sm:right-2 w-20 sm:w-24 h-auto"
          />
        </div>
      </div>
      <div className="flex flex-col-reverse md:flex-row gap-6 md:gap-12 md:items-start">
        <div data-aos="zoom-in" className="flex flex-col gap-3 md:flex-1">
          <div className="font-bold text-sm tracking-widest text-arsen-secondary-500 uppercase">
            TENTANG KOMPETISI
          </div>
          <p className="text-justify text-gray-700 text-md">
            <span className="font-bold">
              Airlangga Statistics Essay Competition
            </span>
            <span className="font-normal">
              {" "}
              (ASEC) pada kegiatan ARSEN 2026 merupakan ajang bergengsi yang
              ditujukan bagi mahasiswa/mahasiswi perguruan tinggi di Indonesia
              yang memiliki minat dalam penulisan karya tulis esai. Dengan
              mengangkat tema{" "}
              <b>
                Transforming Data from Fragmented Realities into Clarity through
                Statistical Methods to Navigate Global Volatility,
              </b>{" "}
              kompetisi ini mengajak peserta untuk menuangkan gagasan inovatif
              mengenai pemanfaatan metode statistika dalam mengolah data yang
              kompleks menjadi informasi yang bermakna. Melalui karya esai,
              peserta diharapkan mampu menawarkan solusi yang berbasis data,
              kritis, dan aplikatif dalam menjawab berbagai tantangan global
              serta mendukung pengambilan keputusan yang lebih tepat di tengah
              dinamika dan ketidakpastian dunia.
            </span>
          </p>
          <div className="mt-3">
            <Pricing
              color="secondary"
              batches={[
                {
                  name: "Batch 1",
                  price: 70000,
                  period: "15 Agustus – 5 September 2026",
                },
                {
                  name: "Batch 2",
                  price: 90000,
                  period: "7 September – 20 September 2026",
                },
              ]}
              note="Dapat diikuti secara individu atau tim yang terdiri dari maksimal 2 orang."
            />
          </div>
        </div>
        <div
          data-aos="zoom-in"
          className="flex w-full flex-col items-center gap-2 md:w-1/3 md:flex-none"
        >
          <div className="font-bold text-sm tracking-widest text-gray-600 uppercase">
            POSTER KEGIATAN
          </div>
          <div className="w-2/3 sm:w-1/2 md:w-full">
            <Image
              src="/assets/img/poster/Poster ASEC 2026.jpg"
              alt="ASEC Poster"
            />
          </div>
        </div>
      </div>
      <div data-aos="zoom-in" className="flex flex-col gap-3 mb-4">
        <div className="font-bold text-sm tracking-widest text-arsen-secondary-500 uppercase">
          Syarat dan Ketentuan
        </div>
        <Rules rules={rules} />
      </div>
      <div data-aos="zoom-in" className="flex flex-col gap-3" id="timeline">
        <div className="font-bold text-sm tracking-widest text-arsen-secondary-500 uppercase">
          TIMELINE KOMPETISI ASEC
        </div>
        <div className="grid grid-cols-1 gap-x-8 gap-y-2 md:grid-cols-2 lg:grid-cols-4">
          <Timeline month={"Agustus"}>
            <TimelineBlock date="15 Agustus – 5 September 2026">
              Pendaftaran Batch 1
            </TimelineBlock>
            <TimelineBlock date="6 September 2026">
              Technical Meeting 1
            </TimelineBlock>
          </Timeline>
          <Timeline month="September">
            <TimelineBlock date="7 September – 20 September 2026">
              Pendaftaran Batch 2
            </TimelineBlock>
            <TimelineBlock date="21 – 27 September 2026">
              Pengumpulan Karya
            </TimelineBlock>
          </Timeline>
          <Timeline month="Oktober">
            <TimelineBlock date="1 – 9 Oktober 2026">
              Babak Penyisihan
            </TimelineBlock>
            <TimelineBlock date="18 Oktober 2026">
              Pengumuman Finalis
            </TimelineBlock>
            <TimelineBlock date="19 – 21 Oktober 2026">
              Registrasi Ulang Finalis
            </TimelineBlock>
            <TimelineBlock date="24 Oktober 2026">
              Technical Meeting 2
            </TimelineBlock>
            <TimelineBlock date="31 Oktober 2026">
              Babak Final & Closing Ceremony
            </TimelineBlock>
          </Timeline>
        </div>
      </div>
      <div data-aos="fade-right" className="flex flex-col gap-4 mt-12 mb-6">
        <div className="font-bold text-sm tracking-widest text-arsen-secondary-500 uppercase">
          Informasi Lainnya
        </div>
        {isCountdownEnded && (
          <>
            <div className="flex-col justify-start md:items-start flex">
              <div className="text-center md:text-left text-black text-[32px] font-bold">
                What Are You Waiting For?
              </div>
            </div>
            <div className="flex flex-col md:flex-row gap-2.5 text-sm text-center md:text-left text-white mb-8">
              <Link
                to="https://bit.ly/PendaftaranASEC2026"
                target="_blank"
                className="bg-arsen-secondary md:w-fit text-center px-8 py-3 rounded-lg transition duration-500 hover:bg-black hover:shadow-xl"
              >
                Pendaftaran
              </Link>
              <Link
                to="https://bit.ly/GuidebookASEC2026"
                target="_blank"
                className="text-center text-arsen-secondary border border-arsen-secondary md:w-fit px-8 py-3 rounded-lg transition duration-500 hover:bg-black hover:text-white hover:shadow-xl"
              >
                Panduan
              </Link>
              <Link
                to="https://bit.ly/PengumpulanKaryaASEC2026"
                target="_blank"
                className="text-center text-arsen-secondary border border-arsen-secondary md:w-fit px-8 py-3 rounded-lg transition duration-500 hover:bg-black hover:text-white hover:shadow-xl"
              >
                Pengumpulan Karya
              </Link>
            </div>
          </>
        )}
      </div>
      <div data-aos="fade-right">
        <ContactCard event="ASEC" />
      </div>
    </div>
  );
}

export default Asec;
